import io from 'socket.io-client';

import { API_SOCKET_URL } from '@/settings';

import { loginAccounts } from './accounts';

class Socket {
  private socket = io(API_SOCKET_URL, {
    query: {
      context: 'learner',
      sessionid: localStorage.getItem('socketSessionId')
    },
    reconnectionDelay: 60000,
    reconnectionDelayMax: 300000
  });

  constructor() {
    this.socket.on('learner-sessionid', (socketSessionId: string) => {
      localStorage.setItem('socketSessionId', socketSessionId);
    });

    this.socket.on('logout', async (sessionId: string) => {
      const currSessionId = localStorage.getItem('socketSessionId');

      if (sessionId !== currSessionId) {
        loginAccounts();
      }
    });
  }

  public emit(event: string, ...args: any[]) {
    this.socket.emit(event, ...args);
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  public on(event: string, fn: Function) {
    this.socket.on(event, fn);
  }
}

export default new Socket();
